// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3006": "8cfe287bd5cb","3616": "2bd20f1d2224","5420": "fbe64e691f1c","6495": "a9b28c737317",}[chunkId] + ".css"
}